export const getBillingAccountOptions = (store) => {
  const billingAccounts = store.billing.billingAccounts;

  return billingAccounts.map((item) => ({ value: item.customer, label: item.alias }));
};
